import { iots } from '@code-expert/prelude';
import { query } from '/imports/modules/Routing';

const runnerSectionKeys = {
  status: null,
  settings: null,
};

export type RunnerSection = keyof typeof runnerSectionKeys;

export const runnerSectionQuery = query(
  iots.exact(iots.partial({ section: iots.keyof(runnerSectionKeys) })),
);
